module.exports = __webpack_public_path__ + "static/media/hand-holding-box.f60cd831.svg";